const tr = {
    home: {
      seo: {
        title: "Dt. Mert Sakarya Diş Kliniği - Bayrampaşa, İstanbul | İmplant, Estetik Diş, Ortodonti",
        description: "Bayrampaşa, İstanbul'da Dt. Mert Sakarya Diş Kliniği; implant, estetik diş hekimliği, kanal tedavisi, ortodonti, diş beyazlatma ve daha fazlasını sunar. WhatsApp üzerinden randevu alın.",
      },
    },
    blogPage: {
      heroTitle: "Blog",
      heroSubtitle: "Diş sağlığı, estetik ve tedavi yöntemleri ile ilgili güncel içerikler.",
      readMore: "Devamını Oku",
      seoTitle: "Blog - Dt. Mert Sakarya Diş Kliniği",
      seoDescription: "Dt. Mert Sakarya Diş Kliniği'nden diş sağlığı, estetik diş hekimliği, tedavi fiyatları ve yurt dışından gelen hastalar için bilgilendirici yazılar.",
      notFoundTitle: "Yazı Bulunamadı",
      notFoundText: "Aradığınız blog yazısı kaldırılmış veya taşınmış olabilir.",
      backToBlog: "Blog'a Dön",
      allPosts: "Tüm Yazılar",
    },
    about: {
        eyebrow: "KLİNİĞİMİZ",
        title: "Hakkımızda",
        paragraph1: "Dt.Mert Sakarya Muayenehanesi olarak sağlıklı, estetik bir gülüşü herkes için erişilebilir kılıyoruz. Modern yöntemleri deneyimli ekibimizle bir araya getirip, titiz hijyen standartlarıyla güvenilir ve konforlu bir tedavi deneyimi sunuyoruz.",
        paragraph2: "",
        showMore: "Daha fazla bilgi",
        showLess: "Daha az göster",
        missionTitle: "Misyonumuz",
        missionText: "Diş sağlığının ötesinde; estetik, şeffaflık, güven ve hijyeni önceleyen, her hastaya özel ve konforlu bir deneyim sunmak.",
        visionTitle: "Vizyonumuz",
        visionText: "Türkiye genelinde örnek alınan, yenilikçi tedavileriyle hasta memnuniyetini her zaman en üst düzeyde tutan bir klinik olmak.",
        valuesTitle: "Değerlerimiz",
        valuesText: "Siz de Dt.Mert Sakarya Muayenehanesi'nde profesyonel ve güvenilir bir tedavi deneyimi yaşayabilirsiniz."
      },
      info: {
        doctor: "DOKTOR",
        doctorCount: "4+",
        happyTreatments: "MUTLU TEDAVİ",
        happyTreatmentsCount: "14000+",
        activeClinics: "AKTİF MUAYENEHANE",
        activeClinicsCount: "4+",
        services: "HİZMETLERİMİZ",
        servicesCount: "50+"
      },
       hero: {
        title: "Sağlıklı ve Estetik Gülüşler",
        subtitle: "Dt.Mert Sakarya Muayenehanesi ile güvenli ve modern diş tedavileri",
        button: "Randevu Al",
        labels: ["Doğal Gülüş", "Dijital Teknoloji", "Uzman Tedavi"],
        quote: "İnsanın başındaki her diş, bir elmastan daha değerlidir.",
        quoteAuthor: "Miguel de Cervantes, Don Kişot, 1605",
        doctorsPreview: [
          { name: "Hakan Kayhan", tagline: "Protez & Gülüş Tasarımı" },
          { name: "Mert Sakarya", tagline: "İmplant & Protez Uzmanı" }
        ]
      },
      whatsapp: {
  greeting: "Merhaba, Dt. Mert Sakarya Muayenehanesi web sitesi üzerinden yazıyorum!",
  cta: "WhatsApp'tan bize yazın!",
},
contact: {
  title: "İletişim",
  seoDescription: "Bayrampaşa, İstanbul'daki Dt. Mert Sakarya Diş Kliniği'ne ulaşın: adres, telefon, WhatsApp ve yol tarifi ile hızlıca randevu alın.",
  bookOnline: "Online Randevu Al",
  bookOnlineSubtitle: "Tedavi ve doktor seçerek birkaç adımda uygun randevu saatini seç.",
  bookOnlineFallback: "Randevu formu görünmüyorsa buraya tıklayın",
  address: "Adres",
  reachUs: "Bize Ulaşın",
  hours: "Çalışma Saatlerimiz",
  newMessage: "Yeni hasta Mesajı:",
  name: "İsim",
  email: "Email",
  phone: "Telefon",
  message: "Mesaj",
  sending: "Mesajınız WhatsApp’a yönlendiriliyor...",
  namePlaceholder: "İsminiz",
  emailPlaceholder: "Email",
  phonePlaceholder: "Telefon",
  messagePlaceholder: "Mesajınız",
  sendingButton: "Gönderiliyor...",
  sendButton: "WhatsApp Üzerinden Gönder"
},
map: {
  eyebrow: "ULAŞIM",
  title: "Konumumuz",
  subtitle: "Bayrampaşa'nın merkezinde, kolay ulaşılabilir bir konumdayız."
},
reviews: {
  eyebrow: "HASTA YORUMLARI",
  title: "Google Yorumları"
},
doctors: {
      eyebrow: "UZMAN KADRO",
      title: "Doktorlarımız",
      seoDescription: "Bayrampaşa, İstanbul'daki Dt. Mert Sakarya Diş Kliniği'nin deneyimli diş hekimleriyle tanışın.",
      list: [
        {
          name: "Hakan Kayhan",
          title: "Diş Hekimi",
          description:
            "Diş Hekimi Hakan Kayhan, 2019 yılında Bezmialem Vakıf Üniversitesi Diş Hekimliği Fakültesinden mezun olmuştur. Mezuniyetinin ardından çeşitli hastane ve polikliniklerde diş hekimi olarak görev yapmıştır. Protez uygulamaları ve gülüş tasarımı alanındaki bilgi ve deneyimiyle, hastalarının sağlıklı ve estetik gülüşlere kavuşmasına yardımcı olmaktadır."
        },
        {
          name: "Mert Sakarya",
          title: "Diş Hekimi  ",
          description:
            "Diş Hekimi Mert Sakarya, Bezmialem Vakıf Üniversitesi Diş Hekimliği bölümünden mezun olmuştur. Mezuniyetinin ardından kendi muayenehanesinde diş hekimi olarak görev yapmıştır. İmplant ve protez uygulamaları alanındaki bilgi ve deneyimiyle, hastalarının sağlıklı ve estetik gülüşlere kavuşmasına yardımcı olmaktadır."
        }
      ]
    },
    services: {
  eyebrow: "NELER SUNUYORUZ",
  title: "Hizmetlerimiz",
  details: "Detayları Gör",
  cards: [
    { text: "İmplant Tedavisi", description: "Eksik dişlerinizi tamamlayarak hem görünümünüzü hem de yaşam kalitenizi artıran profesyonel implant çözümleri.", link: "/implant" },
    { text: "Estetik Diş Hekimliği", description: "Gülüş tasarımı, Hollywood Smile, Bonding ve diğer estetik tedavilerle mükemmel bir gülümseme.", link: "/estetik-dis" },
    { text: "Kanal Tedavisi", description: "Enfekte dişleri kurtararak ağız sağlığınızı koruyan modern kanal tedavisi uygulamaları.", link: "/kanal" },
    { text: "Diş Beyazlatma", description: "Güvenli ve etkili beyazlatma yöntemleriyle ışıl ışıl dişlere kavuşun.", link: "/dis-beyazlatma" },
    { text: "Çocuk Diş Hekimliği", description: "Çocuklara özel, konforlu ve güvenli diş tedavileriyle sağlıklı gülüşler.", link: "/cocuk-dis" },
    { text: "Diş Teli Tedavisi", description: "Diş ve çene hizalamasını düzelten, estetik gülüş sağlayan ortodontik tedaviler.", link: "/dis-teli" },
    { text: "Diş Eti Tedavisi", description: "Diş eti hastalıklarını önleyen ve sağlıklı diş yapısını koruyan etkili çözümler.", link: "/dis-eti" },
    { text: "Ortodonti", description: "Hassas ve etkili ortodontik çözümler ile ideal gülüş.", link: "/ortodonti" },
    { text: "Bruksizm Tedavisi", description: "Diş gıcırdatma problemini ortadan kaldırarak dişlerinizi koruyun.", link: "/bruksizm" }
  ]
},
footer: {
        addressTitle: "Adres",
        addressLine1: "Yıldırım, Ali Fuat Başgil Cd. No:122/A",
        addressLine2: "34045 Bayrampaşa / İstanbul",
        contactTitle: "Bize Ulaşın",
        phone1: "+90 531 964 2737",
        phone2: "+90 212 640 6061",
        hoursTitle: "Çalışma Saatlerimiz",
        hoursWeek: "Pzt-Cum: 11.00 - 23.00",
        hoursWeekend: "Cts-Paz: 11.00 - 17.00",
        copyright: "© 2026 Mert Sakarya Muayenehanesi. Tüm Hakları Saklıdır.",
        seoText: "Diş Beyazlatma, Protez Diş, İmplant, Porselen Diş, Kanal Tedavisi, Diş Dolgusu, Ortodonti, Diş Kaplama, Zirkonyum Kaplama, Zirkon, Diş Teli, Şeffaf Plak, Bayrampaşa Diş Klinik, Bayrampaşa Dişçi, Bayrampaşa Diş kliniği, Bayrampaşa, Yıldırım, Diş Kliniği, Diş, Gülüş Tasarımı, Hollywood Smile, Diş Kliniği, Dişçi, İstanbul Diş, Türkiye Diş"
      },
      navbar: {
        home: "Mert Sakarya Muayenehanesi",
        team: "Kadromuz",
        about: "Hakkımızda",
        prices: "Fiyat Listesi",
        blog: "Blog",
        contact: "İletişim",
      },
      price: {
    title: "Fiyat Listesi",
    seoTitle: "Diş Tedavisi Fiyatları - Dt. Mert Sakarya Diş Kliniği (Bayrampaşa, İstanbul)",
    seoDescription: "İstanbul'da şeffaf diş tedavi fiyatları: implant, protez, ortodonti, beyazlatma ve daha fazlası, yaklaşık USD/EUR karşılıklarıyla.",
    currencyNote: "Fiyatlar Türk Lirası (₺) olarak tahsil edilir. USD/EUR karşılıkları güncel döviz kuruna göre yaklaşık olarak verilmiştir; net fiyat ücretsiz muayene sonrası netleşir.",
    tableHeaders: { treatment: "Tedavi Adı", range: "Fiyat Aralığı" },
    kanalDolgu: {
      title: "Kanal ve Dolgu Tedavi Fiyatları",
      dolgu: "Dolgu",
      kanal: "Kanal",
      retreatment: "Retreatment (Kanal Yenileme)",
    },
    cocuk: {
      title: "Çocuk Diş Tedavi Fiyatları",
      dolgu: "Dolgu",
      kanal: "Kanal",
      disCekimi: "Diş Çekimi",
      sutDisCekimi: "Süt Diş Çekimi",
      amputasyon: "Amputasyon",
      yerTutucu: "Yer Tutucu",
    },
    disCekimi: {
      title: "Diş Çekimi Fiyatları",
      disCekimi: "Diş Çekimi",
      komplikasyonlu: "Komplikasyonlu Diş Çekimi",
      yirmilik: "20'lik Diş Çekimi",
      gomulu: "Gömülü Diş Çekimi (Kemik Retansiyonlu)",
    },
    estetik: {
      title: "Estetik Diş Tedavi Fiyatları",
      estetikDolgu: "Estetik Dolgu",
      disBeyazlatma: "Diş Beyazlatma",
      disTasTemizligi: "Diş Taş Temizliği",
      zirkonyum: "Zirkonyum Kaplama",
      yaprakLamina: "Yaprak Lamina",
      eMax: "E-MAX",
    },
    implant: {
      title: "İmplant Tedavi Fiyatları",
      ithal: "İthal İmplant (Protez Hariç)",
      premiumIthal: "Premium İthal İmplant (Protez Hariç)",
    },
    protez: {
      title: "Protez Tedavi Fiyatları",
      total: "Total Protez (Tek Çene)",
      ustuTotal: "İmplant Üstü Total Protez",
      porselen: "Porselen Kaplama",
    },
    ortodonti: {
      title: "Ortodonti Tedavi Fiyatları",
      tel: "Tel Tedavisi",
      telsiz: "Telsiz Ortodonti (Şeffaf Plak) Tedavisi",
    },
  }, whitening: {
    "metaTitle": "Diş Beyazlatma - dtMertSakarya",
    "metaDescription": "Güvenli ve etkili diş beyazlatma yöntemleriyle ışıl ışıl bir gülüşe sahip olun. Evde veya klinikte uygulama seçenekleriyle.",
    "title": "Diş Beyazlatma",
    "description": "Güvenli ve etkili beyazlatma yöntemleriyle ışıl ışıl dişlere kavuşun. Evde veya klinikte modern uygulamalarla sağlıklı ve estetik bir gülüş elde edin.",
    "whyTitle": "Neden Diş Beyazlatma?",
    "whyText": "Dişler zamanla çay, kahve, sigara ve yaşlanma gibi etkenlerle renk değiştirir. Profesyonel beyazlatma işlemleriyle dişlerinizin doğal beyazlığı geri kazanılır ve estetik bir gülüş elde edilir.",
    "steps": [
      "Muayene ve diş kontrolü",
      "Beyazlatma planlaması",
      "Uygulama süreci",
      "Bakım ve öneriler"
    ],
    "advantagesTitle": "Beyazlatmanın Avantajları",
    "advantages": [
      {
        "title": "Estetik Gülüş",
        "desc": "Daha parlak ve etkileyici bir gülüş."
      },
      {
        "title": "Hızlı Sonuç",
        "desc": "Kısa sürede gözle görülür beyazlık."
      },
      {
        "title": "Güvenli Yöntem",
        "desc": "Diş minesine zarar vermeyen profesyonel yöntemler."
      },
      {
        "title": "Uzun Süre Kalıcı",
        "desc": "Doğru bakım ile uzun süre beyazlık korunur."
      }
    ]
  }, bruxism: {
  "metaTitle": "Bruksizm Tedavisi - dtMertSakarya",
  "metaDescription": "Diş gıcırdatma problemini ortadan kaldıran modern bruksizm tedavileri. Diş sağlığınızı koruyun.",
  "title": "Bruksizm Tedavisi",
  "description": "Diş gıcırdatma ve sıkma problemlerini ortadan kaldırarak dişlerinizi ve çene sağlığınızı koruyan modern çözümler.",
  "whyTitle": "Bruksizm Nedir?",
  "whyText": "Bruksizm, genellikle uykuda diş sıkma veya gıcırdatma olarak görülen yaygın bir problemdir. Uzun vadede diş aşınmasına, çene ağrısına ve baş ağrılarına yol açabilir.",
  "steps": [
    "Teşhis ve değerlendirme",
    "Ağız koruyucu aparey uygulaması",
    "Çene egzersizleri ve takip",
    "Gerekirse diş restorasyonu"
  ],
  "advantagesTitle": "Bruksizm Tedavisinin Avantajları",
  "advantages": [
    { "title": "Diş Sağlığı", "desc": "Dişlerde aşınma ve kırılmayı önler." },
    { "title": "Çene Konforu", "desc": "Çene ve eklem ağrılarını azaltır." },
    { "title": "Baş Ağrısı Azaltma", "desc": "Gündüz ve gece baş ağrılarını hafifletir." },
    { "title": "Rahat Uyku", "desc": "Uyku kalitesini artırır ve stresi azaltır." }
  ]
}, gum: {
    "metaTitle": "Diş Eti Tedavisi - dtMertSakarya",
    "metaDescription": "Diş eti hastalıklarını önleyen ve sağlıklı diş yapısını koruyan modern tedavi çözümleri.",
    "title": "Diş Eti Tedavisi",
    "description": "Diş eti hastalıklarını önleyen ve sağlıklı diş yapısını koruyan etkili çözümler.",
    "whyTitle": "Neden Diş Eti Tedavisi?",
    "whyText": "Sağlıklı diş etleri, dişlerin uzun ömürlü ve güçlü kalmasını sağlar. Tedavi ile iltihap, kanama ve hassasiyet önlenir.",
    "steps": [
      "Muayene ve teşhis",
      "Diş taşı ve plak temizliği",
      "Gerekli cerrahi müdahaleler",
      "Takip ve bakım önerileri"
    ],
    "advantagesTitle": "Diş Eti Tedavisi Avantajları",
    "advantages": [
      { "title": "Sağlıklı Dişler", "desc": "Diş eti sağlığı, dişlerinizi uzun süre korur." },
      { "title": "Ağız Hijyeni", "desc": "İltihap ve bakterileri önleyerek ağız hijyenini artırır." },
      { "title": "Konforlu Tedavi", "desc": "Minimal invaziv ve etkili uygulamalarla rahat bir süreç." },
      { "title": "Uzun Süreli Sonuç", "desc": "Düzenli bakım ile tedavi sonrası sağlık uzun süre devam eder." }
    ]
  }, cocuk: {
    seo: {
      title: "Çocuk Diş Hekimliği - dtMertSakarya",
      description: "Çocuklara özel, konforlu ve güvenli diş tedavileriyle stressiz ve dostane bir ortamda sağlıklı gülüşler.",
    },
    hero: {
      heading: "Çocuk Diş Hekimliği",
      text: "Çocuklarınız için konforlu ve kaygısız diş tedavileri; ilk ziyaretten itibaren güven oluşturan, çocuk odaklı ve güler yüzlü bir ekiple.",
    },
    details: {
      heading: "Neden Çocuk Diş Hekimliği?",
      text: "Çocukların diş ve çene yapısı hâlâ gelişim aşamasındadır, bu yüzden erken muayene ve koruyucu bakım büyük önem taşır. Çocukların diş tedavilerine karşı olumlu bir tutum geliştirmesi için nazik ve sabırlı bir yaklaşım benimsiyoruz.",
    },
    steps: [
      "Dostane ilk muayene ve tanışma süreci",
      "Koruyucu bakım: florür uygulaması ve fissür örtücü",
      "Çürük ve süt dişi sorunlarının tedavisi",
      "Düzenli takip ve ebeveynlere alışkanlık önerileri"
    ],
    advantages: {
      heading: "Çocuk Diş Hekimliği Yaklaşımımızın Avantajları",
      items: [
        { title: "Çocuk Dostu Ortam", desc: "Çocukların endişelerini azaltan sakin ve sıcak bir ortam." },
        { title: "Koruyucu Yaklaşım", desc: "Erken müdahale ileride oluşabilecek büyük sorunların önüne geçer." },
        { title: "Nazik Teknikler", desc: "Yaşa uygun, konforlu tedavi yöntemleri." },
        { title: "Ebeveyn Yönlendirmesi", desc: "Fırçalama, beslenme ve ev bakımı hakkında pratik öneriler." }
      ],
    },
  }, orthodontics: {
    "meta": {
      "title": "Diş Teli Tedavisi - dtMertSakarya",
      "description": "Diş ve çene hizalamasını düzelten modern ortodontik çözümlerle estetik bir gülüş kazanın."
    },
    "title": "Diş Teli Tedavisi",
    "subtitle": "Diş ve çene hizalamasını düzelten, estetik ve fonksiyonel sonuçlar sunan ortodontik tedaviler.",
    "imageAlt": "Diş Teli Tedavisi",
    "whyTitle": "Neden Diş Teli?",
    "whyText": "Diş teli tedavisi ile dişler düzgün hizalanır, estetik bir gülüş elde edilir ve çiğneme fonksiyonu düzelir.",
    "steps": {
      "1": "Muayene ve planlama",
      "2": "Ortodontik aparatın uygulanması",
      "3": "Düzenli takip ve ayarlamalar",
      "4": "Tedavi tamamlanması ve pekiştirme"
    },
    "advantagesTitle": "Diş Teli Tedavisi Avantajları",
    "advantages": {
      "1": { "title": "Estetik Gülüş", "desc": "Dişler düzgün hizalanır ve güzel bir görünüm kazanır." },
      "2": { "title": "Fonksiyonel Düzeltme", "desc": "Çiğneme ve konuşma fonksiyonlarını iyileştirir." },
      "3": { "title": "Uzun Süreli Etki", "desc": "Tedavi sonrası düzgün diş dizilimi uzun süre korunur." },
      "4": { "title": "Farklı Seçenekler", "desc": "Metal, şeffaf veya hareketli aparey seçenekleri mevcuttur." }
    }
  }, esthetic:{
    "seo": {
      "title": "Estetik Diş Hekimliği - dtMertSakarya",
      "description": "Gülüş tasarımı, Hollywood Smile ve Bonding ile mükemmel estetik çözümler. Estetik diş hekimliği hakkında detaylar."
    },
    "hero": {
      "heading": "Estetik Diş Hekimliği",
      "text": "Estetik diş tedavileriyle gülüşünüzü yeniden keşfedin. Diş rengi, formu ve dizilimi üzerinde yapılan profesyonel uygulamalarla doğal ve çekici bir görünüm elde edin.",
      "button": "Randevu Al"
    },
    "details": {
      "heading": "Estetik Diş Tedavisi Nedir?",
      "text": "Estetik diş hekimliği; dişlerin rengi, şekli, boyutu ve dizilimiyle ilgili sorunları ortadan kaldırarak daha güzel bir gülüş tasarımı sunar. Gülüş estetiği uygulamaları kişiye özel planlanır ve doğal sonuçlar hedeflenir."
    },
    "steps": [
      "Dijital gülüş tasarımı",
      "Porselen laminate veneer (yaprak diş)",
      "Kompozit bonding uygulamaları",
      "Diş beyazlatma işlemleri"
    ],
    "advantages": {
      "heading": "Estetik Diş Hekimliğinin Avantajları",
      "items": [
        { "title": "Doğal Gülüş", "desc": "Yüz hatlarıyla uyumlu doğal bir görünüm sağlar." },
        { "title": "Hızlı Sonuç", "desc": "Kısa sürede gözle görülür estetik değişiklikler elde edilir." },
        { "title": "Kişiye Özel Tasarım", "desc": "Her hasta için yüz oranlarına göre planlanır." },
        { "title": "Kalıcı Etki", "desc": "Uygulanan malzemeler uzun ömürlü ve dayanıklıdır." }
      ]
    }
  },
  common:{
    bookAppointment: "Randevu Al",
   },

 
  implant: {
    seo: {
      title: "İmplant Tedavisi - dtMertSakarya",
      description: "Eksik dişlerinizi tamamlayın ve sağlıklı gülüşler elde edin. Modern ve güvenli implant tedavi çözümleri.",
    },
    hero: {
      heading: "İmplant Tedavisi",
      text: "Eksik dişlerinizi tamamlayan modern implant çözümleri ile hem görünümünüzü hem yaşam kalitenizi artırın. Konforlu ve güvenli işlemlerle sağlıklı gülüşler.",
      button: "Randevu Al",
    },
    details: {
      heading: "Neden İmplant?",
      text: "İmplantlar, doğal diş görünümünü ve işlevini geri kazandırır, çiğneme konforu sağlar ve çene kemiğini destekler. Uzun ömürlü ve güvenilir bir çözümdür.",
    },
    steps: [
      "Muayene ve planlama",
      "İmplant yerleştirme operasyonu",
      "İyileşme ve takip süreci",
      "Protez uygulaması"
    ],
    advantages: {
      heading: "İmplant Tedavisinin Avantajları",
      items: [
        { title: "Doğal Görünüm", desc: "Doğal dişler gibi görünür ve hissedilir." },
        { title: "Uzun Ömürlü", desc: "Doğru bakım ile yıllarca sorunsuz kullanılabilir." },
        { title: "Kemik Sağlığı", desc: "Çene kemiğini korur ve kemik kaybını önler." },
        { title: "Konforlu Çiğneme", desc: "Doğal dişler gibi rahat çiğneme sağlar." }
      ],
    },
  },

   kanal:{
  "seo": {
    "title": "Kanal Tedavisi - dtMertSakarya",
    "description": "Enfekte dişleri kurtararak ağız sağlığınızı koruyan modern kanal tedavisi yöntemleri. İşlem adımları ve avantajlar."
  },
  "hero": {
    "heading": "Kanal Tedavisi",
    "text": "Dişin iç kısmında oluşan enfeksiyonları gidererek dişinizi kurtaran modern kanal tedavisi yöntemleri. Ağrısız, konforlu ve etkili bir tedavi süreciyle sağlıklı gülüşler."
  },
  "details": {
    "heading": "Neden Kanal Tedavisi?",
    "text": "Kanal tedavisi, dişin içindeki enfekte olmuş sinir dokusunun temizlenmesi ve dişin yeniden yapılandırılması işlemidir. Bu sayede diş çekilmeden ağız sağlığı korunur ve doğal diş yapısı muhafaza edilir."
  },
  "steps": [
    "Röntgen ve muayene",
    "Kanalın temizlenmesi",
    "Dezenfeksiyon işlemi",
    "Kanal dolgu ve kaplama"
  ],
  "advantages": {
    "heading": "Kanal Tedavisinin Avantajları",
    "items": [
      { "title": "Doğal Dişi Korur", "desc": "Diş çekimi yerine dişin doğal yapısı korunur." },
      { "title": "Ağrısız Tedavi", "desc": "Modern tekniklerle konforlu bir tedavi sağlanır." },
      { "title": "Uzun Ömürlü Sonuç", "desc": "Tedavi edilen diş yıllarca sorunsuz kullanılabilir." },
      { "title": "Estetik Görünüm", "desc": "Dolgu veya kaplamayla estetik bir görünüm elde edilir." }
    ]
  }
}, ortodonti:{
  "seo": {
    "title": "Ortodonti - dtMertSakarya",
    "description": "Hassas ve etkili ortodontik çözümler ile ideal gülüş ve diş hizalaması. Ortodonti hakkında detaylı bilgi."
  },
  "hero": {
    "heading": "Ortodonti",
    "text": "Diş ve çene hizalamasını düzelten ortodontik tedavilerle estetik ve sağlıklı bir gülüş. Modern teknikler ve kişiye özel planlamalarla rahat ve etkili tedavi süreçleri."
  },
  "details": {
    "heading": "Neden Ortodonti?",
    "text": "Ortodonti, diş ve çene yapısındaki bozuklukları düzelterek doğru kapanış, estetik bir gülüş ve ağız sağlığının korunmasını sağlar. Hem çocuklar hem yetişkinler için uygundur."
  },
  "steps": [
    "Muayene ve teşhis",
    "Diş ve çene ölçümleri",
    "Tel veya aparey uygulaması",
    "Takip ve ayarlamalar"
  ],
  "advantages": {
    "heading": "Ortodonti Avantajları",
    "items": [
      { "title": "Düzgün Dişler", "desc": "Estetik ve düzgün bir diş dizilimi sağlar." },
      { "title": "Doğru Çiğneme", "desc": "Çiğneme fonksiyonunu optimize eder." },
      { "title": "Uzun Süreli Sağlık", "desc": "Diş sağlığını korur ve aşınmayı önler." },
      { "title": "Özgüven Artışı", "desc": "Gülüş tasarımı ile kendine güveni artırır." }
    ]
  }
},
notFound: {
  seoTitle: "Sayfa Bulunamadı - Dt. Mert Sakarya Diş Kliniği",
  seoDescription: "Aradığınız sayfa bulunamadı. Ana sayfaya dönerek Dt. Mert Sakarya Diş Kliniği hizmetlerini keşfedin.",
  heading: "404",
  title: "Sayfa Bulunamadı",
  text: "Aradığınız sayfa kaldırılmış, taşınmış ya da hiç var olmamış olabilir.",
  backHome: "Ana Sayfaya Dön",
}
};
export default tr;